export const LocationSubscriptionSummaryFragment = /* GraphQL */ `
	fragment LocationSubscriptionSummary on Location {
		_id
		updated_at
		no_vat
		no_service_charge
	}
`;
